"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
const fontSizes_1 = require("./fontSizes.cjs");
const fontWeights_1 = require("./fontWeights.cjs");
const letterSpacing_1 = require("./letterSpacing.cjs");
const lineHeights_1 = require("./lineHeights.cjs");
exports.typography = {
    sDisplayLG: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize8,
        lineHeight: lineHeights_1.lineHeights.lineHeight7,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sDisplayMD: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize7,
        lineHeight: lineHeights_1.lineHeights.lineHeight6,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingLG: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize6,
        lineHeight: lineHeights_1.lineHeights.lineHeight5,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingMD: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sHeadingSM: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyLGMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMD: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMDMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyMDBold: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySM: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySMMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodySMBold: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sBodyXS: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    sBodyXSMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    sPageHeading: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize6,
        lineHeight: lineHeights_1.lineHeights.lineHeight5,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sSectionHeading: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sButtonLabelMd: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sButtonLabelLg: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    sAmountDisplayLg: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize8,
        lineHeight: lineHeights_1.lineHeights.lineHeight7,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lDisplayLG: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize10,
        lineHeight: lineHeights_1.lineHeights.lineHeight9,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lDisplayMD: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize9,
        lineHeight: lineHeights_1.lineHeights.lineHeight8,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingLG: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize7,
        lineHeight: lineHeights_1.lineHeights.lineHeight6,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingMD: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize6,
        lineHeight: lineHeights_1.lineHeights.lineHeight5,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lHeadingSM: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyLGMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMD: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMDMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyMDBold: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySM: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySMMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodySMBold: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize3,
        lineHeight: lineHeights_1.lineHeights.lineHeight3,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lBodyXS: {
        fontWeight: fontWeights_1.fontWeights.regular,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    lBodyXSMedium: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize2,
        lineHeight: lineHeights_1.lineHeights.lineHeight2,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing1,
    },
    lPageHeading: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize7,
        lineHeight: lineHeights_1.lineHeights.lineHeight6,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lSectionHeading: {
        fontWeight: fontWeights_1.fontWeights.bold,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lButtonLabelMd: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize4,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lButtonLabelLg: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize5,
        lineHeight: lineHeights_1.lineHeights.lineHeight4,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
    lAmountDisplayLg: {
        fontWeight: fontWeights_1.fontWeights.medium,
        fontSize: fontSizes_1.fontSizes.fontSize10,
        lineHeight: lineHeights_1.lineHeights.lineHeight9,
        letterSpacing: letterSpacing_1.letterSpacing.letterSpacing0,
    },
};
//# sourceMappingURL=typography.cjs.map